var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Home")]),_c('udn-lookup',{staticClass:"mb-4"}),_c('hardware-device-lookup',{staticClass:"mb-4"}),_c('h4',[_vm._v("Documentation Tags")]),_c('documentation-tags')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }